<template>
    <span class="preview">
        <span class="preview-image" :style="{ 'background-image': `url(${upload?.base64})` }" />
        <span class="preview-name">{{ ellipsis(upload?.file?.name, 30, 20) }}</span>
        <span class="preview-delete" @click.prevent="removeUpload">
            <waste-bin-icon />
        </span>
    </span>
</template>

<script lang="ts" setup>
import { EmitEvents } from '@btcdirect/shared/src/components/types';
import { ellipsis } from '@btcdirect/shared/src/composables/util/text';
import { UploadedFile } from '../file-field/types';
import WasteBinIcon from '../icons/waste-bin.vue';

const emit = defineEmits([EmitEvents.REMOVED]);

const props = defineProps<{ upload: UploadedFile }>();

const removeUpload = (): void => emit(EmitEvents.REMOVED, props.upload);
</script>

<style lang="scss" scoped>
@use '@@scss/flex';
@use '@@scss/transitions';

.preview {
    @include flex.flex;
    @include flex.align(center);
    background-color: var(--ootv-input-background-color);
    column-gap: 0.75em;
    padding-left: 1rem;
    padding-right: 1rem;

    .preview-image,
    .preview-delete {
        @include flex.resize(0, 0);
    }

    .preview-name {
        @include flex.resize(1);
    }

    .preview-image {
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        border-radius: 0.25em;
        height: 3em;
        overflow: hidden;
        width: 3em;
    }

    .preview-delete {
        @include flex.flex;
        @include flex.align(center, center);
        cursor: pointer;
        height: 2em;
        width: 2em;
    }
}

.notification.btcdirect-warning {
    margin-bottom: 1rem;
}
</style>
